import { render, staticRenderFns } from "./DomainsCreate.vue?vue&type=template&id=52b8484f"
import script from "./DomainsCreate.vue?vue&type=script&lang=js"
export * from "./DomainsCreate.vue?vue&type=script&lang=js"
import style0 from "./DomainsCreate.vue?vue&type=style&index=0&id=52b8484f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports